import { TemplateCta, TemplateFooter, TemplateMeta } from './TemplateParts';

export default function SaveTheDateEtoile({ data }) {
  const {
    artTypeLabel,
    coupleName,
    rows,
    shortPhrase,
    ctaText,
    showSiteLink,
    siteUrl,
    showQrCode,
    textColor,
    textShadow,
    accentColor,
    titleStyle,
    bodyStyle,
    isPremium
  } = data;

  return (
    <div className="absolute inset-0 p-6 flex flex-col">
      <div className="my-auto w-full max-w-[90%] rounded-[28px] border border-white/65 bg-white/88 shadow-[0_20px_42px_rgba(45,31,25,0.22)] p-5 md:p-6 relative overflow-hidden">
        <div className="absolute left-5 top-5 bottom-5 w-px bg-[#D1AE88]/46" />
        <div className="absolute left-5 top-5 h-px w-10 bg-[#D1AE88]/45" />

        <div className="flex items-center justify-between pl-3">
          <span className="rounded-full px-3 py-1 text-[10px] uppercase tracking-[0.14em] font-semibold bg-white/90 text-[#4F3832]">
            {artTypeLabel}
          </span>
          {isPremium && (
            <span className="rounded-full px-3 py-1 text-[10px] uppercase tracking-[0.14em] font-semibold bg-[#2E1F25]/85 text-[#FFF3E2]">
              Premium
            </span>
          )}
        </div>

        <h4 className="mt-4 pl-3 text-[2.3rem] md:text-[3.1rem] font-bold leading-[1.03]" style={titleStyle}>
          {coupleName}
        </h4>

        <div className="mt-4 pl-3">
          <TemplateMeta rows={rows} textColor={textColor} textShadow={textShadow} family={bodyStyle.metaFamily} tracking={bodyStyle.metaTracking} />
        </div>

        {shortPhrase ? (
          <p className="mt-4 pl-3 text-sm md:text-base" style={bodyStyle.style}>
            {shortPhrase}
          </p>
        ) : null}

        {ctaText ? (
          <div className="mt-4 pl-3">
            <TemplateCta text={ctaText} textColor={textColor} textShadow={textShadow} />
          </div>
        ) : null}

        <TemplateFooter
          showSiteLink={showSiteLink}
          siteUrl={siteUrl}
          showQrCode={showQrCode}
          textColor={textColor}
          accentColor={accentColor}
        />
      </div>
    </div>
  );
}
